import configureAxios from 'configure/axios';

const axios = configureAxios();

export const checkout = (purchaseId, card_id) => axios.post(`purchases/${purchaseId}/checkout/`, { capture: true, card_id });
export const allocate_sprint = (plan, subscription) => axios.post('cycles/upcoming/', { plan, subscription });
export const allocate_bypassed = (plan, subscription) => axios.post('bypassed/cycles/upcoming/', { plan, subscription });
